import React from "react";

export default function SkeletonCard(props) {
  if (props.number === 0 && props.page === 1) {
    return (
      <div className="col-12 col-sm-6 col-md-12">
        <div className="insight-teaser image-left skeleton">
          <div className="image" />
          <div className="text">
            <p className="teaser-type insight"></p>
            <h4></h4>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="col-12 col-sm-6 col-md-4">
      <div className="insight-teaser image-top skeleton">
        <div className="image" />
        <div className="text">
          <p className="teaser-type insight"></p>
          <h4></h4>
        </div>
      </div>
    </div>
  );
}
